'use strict';

/* globals define, window, $, config, ajaxify */

define('site-widget', [], function () {
	var	SiteWidget = {};

	SiteWidget.applySiteWidget = function (data) {
		if (!inIframe()) {
			return;
		}

		SiteWidget.setupNavigation();
		SiteWidget.setupBreadcrumbs();

		if (data.url === '' && SiteWidget.isWidgetMode()) {
			SiteWidget.redirectToOrganizationUrl();
		}
	};

	SiteWidget.isWidgetMode = function () {
		return inIframe() && ajaxify.data.widgetMode;
	};

	SiteWidget.redirectToOrganizationUrl = function () {
		window.location.href = config.relative_path + ajaxify.data.widgetPath;
	};

	SiteWidget.setupNavigation = function () {
		var navItemsToRemove = $('#main-nav li:not(:has(a#conferences-nav-item))').remove();

		navItemsToRemove.remove();
	};

	SiteWidget.setupBreadcrumbs = function () {
		console.log(config.relative_url);
		var breadcrumbItemsToRemove = $('ol.breadcrumb li:has(a[href="/forum/"])');

		breadcrumbItemsToRemove.remove();
	};

	function inIframe() {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}

	return SiteWidget;
});
